/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';
import Helmet from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import {WithLocalize} from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';
import { checkUserAgentCustom } from '../../utils';

import './style.scss';
import LoginForm from './LoginForm';
import favicon from './img/favicon.ico';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('es');
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = 'mio'
    document.title = 'MIO - Login';
  }

  render() {
    const {translate} = this.props;

    return (
      <div className='login-container-sup'>
          {!checkUserAgentCustom() &&
          <a href="/" className='backArrow' onClick={(e) => {
              e.preventDefault();
              window.history.back();
            }}>
              <FontAwesomeIcon size="2x" icon={faArrowLeft} color="rgba(0,0,0,0.2)" />
          </a>
        }
        <div className="form container-mio">
          <Helmet>
            <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
          </Helmet>

            {
              this._validateParams()
              ? <LoginForm
                  api={this.api}
                  location={this.props.location}
                />
              : <RequestLoginErrorMessage
                  onlyMessage={true}
                  message={translate('RequestLoginErrorMessage')}
                />
            }
        </div>
      </div>
    );
  }
}

export default WithLocalize(Login);
